<div class="modal fade" id="consultarPedidoModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="consultarPedidModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
            <div class="modal-header" [ngClass]="{'navbar-homolog' : !production, 'bg-primary' : production}">
                <h5 class="modal-title text-white" id="consultarPedidModalLabel">
                    Consultar Pedidos
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"
                    (click)="clear()"></button>
            </div>
            <div class="modal-body">
                <app-loading #appLoading [show]="false"></app-loading>

                <form [formGroup]="form">
                    <div class="row" style="margin-bottom: 0.5em;">
                        <div class="col-2">
                            <label class="form-label">N° do Pedido</label>
                            <input type="number" class="form-control form-control-sm" formControlName="NumeroDoPedido">
                        </div>
                        <div class="col-2">
                            <label class="form-label">Ano</label>
                            <input type="number" class="form-control form-control-sm" formControlName="Ano">
                        </div>
                        <div class="col-2">
                            <label class="form-label">Pedido Siscort</label>
                            <input type="number" class="form-control form-control-sm"
                                formControlName="NumeroDoPedidoSiscort">
                        </div>
                        <div class="col align-self-end" style="width: 10em;">
                            <button type="button" class="btn btn-outline-primary"
                                (click)="getPedido()">Pesquisar</button>
                        </div>
                    </div>
                    <div class="row" style="margin-bottom: 0.5em;">
                        <div class="col">
                            <label class="form-label">Cliente</label>
                            <input type="text" readonly class="form-control form-control-sm"
                                formControlName="ExternalNameClienteComIdSiscort">
                        </div>
                        <div class="col-2">
                            <label class="form-label">Tipo de Remessa</label>
                            <input type="text" readonly class="form-control form-control-sm"
                                formControlName="TipoDeRemessaDesc">
                        </div>
                        <div class="col-2">
                            <label class="form-label">Tipo de Utilização</label>
                            <input type="text" readonly class="form-control form-control-sm"
                                formControlName="TipoDeUtilizacaoDesc">
                        </div>
                        <div class="col">
                            <label class="form-label">Transportadora</label>
                            <input type="text" readonly class="form-control form-control-sm"
                                formControlName="TransportadoraDesc">
                        </div>
                        <div class="col-2">
                            <label class="form-label">Emergência</label>
                            <input type="text" readonly class="form-control form-control-sm"
                                formControlName="EmergenciaDesc">
                        </div>
                         <div class="col-2">
                            <label class="form-label">Vendedor</label>
                            <input type="text" readonly class="form-control form-control-sm"
                                formControlName="EmailCriadoPor">
                        </div>
                    </div>
                </form>

                <div class="row">
                    <div class="col-12">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Item</th>
                                    <th scope="col">Produto</th>
                                    <th scope="col">UM</th>
                                    <th scope="col">Linha/Sublinha</th>
                                    <th scope="col">Cód Produto Cliente</th>
                                    <th scope="col">Item Cliente</th>
                                    <th scope="col">Entrega Fábrica</th>
                                    <th scope="col">Entrega Cliente</th>
                                    <th scope="col">Qtd. Pedido</th>
                                    <th scope="col">Qtd. Faturada</th>
                                    <th scope="col">Valor Total</th>
                                    <th scope="col">Saldo</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Liquidado</th>
                                    <th scope="col">NFs</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of dadosPedidoItens">
                                    <td>{{item.NumeroDoItemFormatado}}</td>
                                    <td>{{item.ProdutoFormatado}}</td>
                                    <td>{{item.IdUnidadeDeMedida}}</td>
                                    <td class="text-center">{{item.ExternalLinhaProduto+'/'+item.ExternalSubLinhaProduto}}</td>
                                    <td>{{item.IdProdutoDoCliente}}</td>
                                    <td>{{item.NumeroDoItemNoCliente}}</td>
                                    <td>{{item.DataEntrega | date: 'dd/MM/yyyy'}}</td>
                                    <td>{{item.DataEntregaCliente | date: 'dd/MM/yyyy'}}</td>
                                    <td>{{item.Quantidade }}</td><!-- | currency:'BRL':'':'1.2-2':'pt-BR' -->
                                    <td>{{item.QuantidadeFaturadaTotal}}</td>
                                    <td>{{item.ValorTotal}}</td>
                                    <!-- | currency:'BRL':'':'1.2-2':'pt-BR' -->
                                    <td>{{item.Saldo }}</td><!-- | currency:'BRL':'':'1.2-2':'pt-BR' -->
                                    <td [style.color]="getStatus(item.IdStatus).Cor">{{getStatus(item.IdStatus).Status }}</td>
                                    <td class="text-center">{{item.FaturamentoLiquidadoDescricao}}</td>
                                    <td>{{item.DescricaoNFs}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" id="closeDuplicarModalButton" class="btn btn-outline-primary"
                    data-bs-dismiss="modal" (click)="clear()">Voltar</button>
            </div>
        </div>
    </div>
</div>
